const formatDescription = (options) => {
  const url = options.url;
  const details = options.details;
  const link = `[${url}|${url}]`;

  if (!details) {
    return link;
  }

  let description = '';

  if (typeof details === 'object') {
    description = _formatDescriptionObject({ object: details });
  } else {
    description = `Description: ${details}`;
  }

  return `${link}\n${description}`;
};

const _formatDescriptionObject = (options) => {
  const object = options.object;
  const diveLevel = options.diveLevel || 1;
  const bullets = '*'.repeat(diveLevel);

  return Object
    .keys(object)
    .reduce((result, key) => {
      let value = object[key];

      if (value && typeof value === 'object') {
        let formattedObject = _formatDescriptionObject({
          object: value,
          diveLevel: diveLevel + 1
        });
        return `${result}\n${bullets} ${key}:${formattedObject}`;
      }

      return value
        ? `${result}\n${bullets} ${key}: ${value}`
        : result;
    }, '');
};

export default formatDescription;
